// @flow

// Libs
import _map from 'lodash/map'

// Exports
export default function asString (value: mixed): string {
  if (value != null) {
    if (typeof value === 'string' || typeof value === 'number') {
      return `${value}`.trim()
    } else if (typeof value === 'boolean') {
      if (value === true) {
        return 'true'
      } else {
        return 'false'
      }
    } else if (Array.isArray(value)) {
      return value.map(asString).join(', ')
    } else if (typeof value === 'object') {
      return asString(_map(value, (v: mixed, k: string): string => {
        return `${k}:${asString(v)}`
      }))
    }
  }

  return ''
}
